import React, { useState, useEffect, useMemo } from "react";
//Routing
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
//design css
import "./App.css";
//images & icons
import roccologo from "./Assets/Roccologo.png";
import { Icon } from "@iconify/react";
//mui implement
import { Alert, Snackbar, Tooltip } from "@mui/material";
//Pages for navigation
import Dashboard from "./Pages/Dashboard/Dashboard";
import Admin from "./Pages/Admin/Admin";
import User from "./Pages/User/User";
import Permissions from "./Pages/Permission/Permissions";
import Products from "./Pages/Product/Products";
import ProductCategories from "./Pages/Product/ProductCategories";
import AdminDetail from "./Pages/Admin/AdminDetail";
import AddAdmin from "./Pages/Admin/AddAdmin";
import UserDetail from "./Pages/User/UserDetail";
import Blocklist from "./Pages/Block/Blocklist";
import SendRcoins from "./Pages/Wallet/SendRcoins";
import BanUser from "./Pages/User/BanUser";
import Pklist from "./Pages/Pk/Pklist";
import SetPk from "./Pages/Pk/SetPk";
import TagsList from "./Pages/Tags/TagsList";
import GiftList from "./Pages/Gift/GiftList";
import CreateGift from "./Pages/Gift/CreateGift";
import AddProduct from "./Pages/Product/AddProduct";
import AgencyList from "./Pages/Agency/AgencyList";
import AddAgency from "./Pages/Agency/AddAgency";
import AgencyDetail from "./Pages/Agency/AgencyDetail";
import EditAgency from "./Pages/Agency/EditAgency";
import BussinessDevelopersList from "./Pages/BusinessDevelopers/BussinessDevelopersList";
import { AddBussinessDevelopers } from "./Pages/BusinessDevelopers/AddBussinessDeveloper";
import CoinsHistory from "./Pages/Wallet/CoinsHistory";
import SendersLevel from "./Pages/SendersList/Senders";
import HostsLevel from "./Pages/HostsList/Hosts";
import { AddSenderLevel } from "./Pages/SendersList/AddSenderLevel";
import { AddHostLevel } from "./Pages/HostsList/AddHostLevel";
import { EditSenderLevel } from "./Pages/SendersList/EditSenderLevel";
import { EditHostLevel } from "./Pages/HostsList/EditHostLevel";
import DiamondsPackages from "./Pages/DiamondPackages/DiamondPackages";
import { AddPackages } from "./Pages/DiamondPackages/AddPackages";
import { EditPackages } from "./Pages/DiamondPackages/EditPackage";
import MomentsApprove from "./Pages/Moments/MomentsApprove";
import AllMoments from "./Pages/Moments/AllMomentsList";
import MomentsPending from "./Pages/Moments/MomentsPending";
import MomentsRejected from "./Pages/Moments/MomentsRejected";
import FamilyList from "./Pages/Family/FamilyList";
import { UpdateFamily } from "./Pages/Family/UpdateFamily";
import BannerImagesList from "./Pages/BannerImages/ImagesList";
import { TextBubbleImages } from "./Pages/TextBubble/TextBubbleList";
import { AddTextBubble } from "./Pages/TextBubble/AddTextBubble";
import { AddUpdateImage } from "./Pages/BannerImages/AddUpdateImage";
import RIDList from "./Pages/SpecialRID/RIDList";
import { AddUpdateSpecialRID } from "./Pages/SpecialRID/AddUpdateRID";
import ProfiletagsList from "./Pages/ProfileTags/ProfileTagsList";
import { AddUpdateProfileTag } from "./Pages/ProfileTags/AddUpdateProfileTag";
import AssignedUsers from "./Pages/Tags/AssignedUsersList";
import AddDiamond from "./Pages/SendDiamond/AddDiamond";
import DiamondList from "./Pages/SendDiamond/DiamondList";
import ProfileTagUsersList from "./Pages/ProfileTags/ProfileTagUsers";
import AssignLevel from "./Pages/SendersList/AssignLevel";
import AssignLevelUsersList from "./Pages/SendersList/AssignLevelUsers";
import UpdateAssignLevel from "./Pages/SendersList/UpdateAssignLevel";
import AssignHostLevel from "./Pages/HostsList/AssignHostLevel";
import AssignHostLevelUsersList from "./Pages/HostsList/AssignHostLevelUsers";
import UpdateAssignHostLevel from "./Pages/HostsList/UpdateHostLevel";
import WithdrawPayment from "./Pages/WithdrawPayment/WithdrawPayment";
import LiveStreamReport from "./Pages/Report/LiveStreamReport";
import DeactivateUser from "./Pages/User/DeactivateUser";
import BannedUser from "./Pages/User/BannedUser";
import GiftHistoryList from "./Pages/Gift/GiftHistoryList";
import Merchand from "./Pages/Merchand/MerchandList";
import AddMerchand from "./Pages/Merchand/AddMerchand";
import AddWithdrawPayment from "./Pages/WithdrawPayment/AddWithdrawPayment";
import HostRequestList from "./Pages/HostRequestList/HostRequestList";
import AllBannersList from "./Pages/Banner/BannerList";
import DeactiveBanners from "./Pages/Banner/DeactiveBanners";
import AddBanner from "./Pages/Banner/AddBanner";
import EditBanner from "./Pages/Banner/EditBanner";
import ActiveBanners from "./Pages/Banner/ActiveBannerList";
import ComingSoon from "./Pages/ComingSoon";
import MomentsVideoApprove from "./Pages/VideoMoments/MomentsVideoApprove";
import MomentsVideoPending from "./Pages/VideoMoments/MomentsPending";
import MomentsVideoReject from "./Pages/VideoMoments/MomentsReject";
import Reseller from "./Pages/Reseller/Reseller";
import Customer from "./Pages/CustomerSupport/CutomerList";
import AddCustomer from "./Pages/CustomerSupport/AddCustomer";
import SvipList from "./Pages/SVIP/SvipList";
import AddSvip from "./Pages/SVIP/AddSvip";
import ChatList from "./Pages/CSRChat/ChatList";
import DonationLog from "./Pages/DonationLog/DonationLog";
import WalletTransaction from "./Pages/WalletTransaction/WalletTransaction";
import GifterRankingList from "./Pages/GifterRanking/GifterRankingList";
import HostList from "./Pages/Ranking/HostList";
import GiftListRank from "./Pages/Ranking/GiftList";
import AddDeactiveUser from "./Pages/User/AddDeactiveUser";
import MomentReport from "./Pages/Moments/MomentReport";
import FamilyReport from "./Pages/Family/FamilyReport";
import WithdrawalsReportList from "./Pages/Withdrawals/WithdrawalsReportList";
import UserReportList from "./Pages/Report/UserReportList";
import InviteList from "./Pages/Ranking/InviteList";
import CreateFamilyRule from "./Pages/FamilyRule/CreateFamilyRule";
import FamilyRuleList from "./Pages/FamilyRule/FamilyRuleList";
import WithdrawRequestList from "./Pages/WithdrawRequest/WithdrawRequestList";
import SingleWithdrawRequest from "./Pages/WithdrawRequest/SingleWithdrawRequest";
import AddReseller from "./Pages/Reseller/AddReseller";
import UserProfile from "./Pages/User/UserProfie";
import AssignHostingLevel from "./Components/Models/AssignHostingLevel";
// sound
import beep from "../src/Assets/audio/beep.mp3";
// Socket
import { connectSocket, getSocket } from "./Socketio/Socket";

const App = ({ onLogout, message }) => {
  const navigate = useNavigate();
  const location = useLocation().pathname;
  // states manage
  const [activeitems, setActiveItems] = useState(null);
  const [activeChilditems, setActiveChildItems] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [socket, setSocket] = useState(null);
  const [socketData, setSocketData] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  //navigations handle here
  const handleitemsClick = (item) => {
    setActiveItems(item.id);
    setActiveChildItems(item.child_id);
    navigate(item.route);
    if (item.children) {
      setOpenDropdown(openDropdown === item.id ? null : item.id);
      setActiveItems(item.child_id);
    }
  };
  //all sideBar items
  const items = useMemo(
    () => [
      {
        id: 1,
        name: "Dashboard",
        route: "/dashboard",
        icon: "material-symbols:space-dashboard",
      },
      {
        id: 2,
        name: "Users",
        icon: "tabler:users",
        children: [
          {
            child_id: 1,
            name: "Active Users",
            route: "/users",
            icon: "tabler:users",
          },
          {
            child_id: 2,
            name: "Deleted Users",
            route: "/deactivate-user",
            icon: "tabler:users",
          },
          {
            child_id: 3,
            name: "Banned Users",
            route: "/banned-user",
            icon: "tabler:users",
          },
          {
            child_id: 4,
            name: "Profile Users",
            route: "/profile-users",
            icon: "tabler:users",
          },
        ],
      },
      {
        id: 3,
        name: "Schedule PK",
        route: "/pk",
        icon: "game-icons:battle-gear",
      },
      {
        id: 4,
        name: "Moments",
        icon: "mingcute:moment-fill",
        children: [
          // {
          //   child_id: 1,
          //   name: "All Moments",
          //   route: "/all-moments",
          //   icon: "mingcute:moment-fill",
          // },
          {
            child_id: 1,
            name: "Pending Moments",
            route: "/moments-pending",
            icon: "mingcute:moment-fill",
          },
          {
            child_id: 2,
            name: "Active Moments",
            route: "/moments-approve",
            icon: "mingcute:moment-fill",
          },

          {
            child_id: 3,
            name: "Rejected Moments",
            route: "/moments-rejected",
            icon: "mingcute:moment-fill",
          },
        ],
      },
      {
        id: 5,
        name: "Video Moments",
        icon: "mingcute:moment-fill",
        children: [
          {
            child_id: 1,
            name: "Pending Video Moments",
            route: "/pending-video-moments",
            icon: "mingcute:moment-fill",
          },
          {
            child_id: 2,
            name: "Active Video Moments",
            route: "/approve-video-moments",
            icon: "mingcute:moment-fill",
          },

          {
            child_id: 3,
            name: "Rejected Video Moments",
            route: "/reject-video-moments",
            icon: "mingcute:moment-fill",
          },
        ],
      },
      {
        id: 6,
        name: "Families",
        route: "/family-list",
        icon: "vaadin:family",
      },
      {
        id: 7,
        name: "Agencies",
        icon: "line-md:list",
        children: [
          {
            child_id: 1,
            name: "All Agencies",
            route: "/agencylist",
            icon: "line-md:list",
          },
          {
            child_id: 2,
            name: "Join Agency Requests",
            route: "/host-list",
            icon: "mdi:users-group",
          },
        ],
      },
      {
        id: 8,
        name: "Ranking",
        icon: "line-md:list",
        children: [
          {
            child_id: 1,
            name: "Host",
            route: "/rank-host-list",
            icon: "line-md:list",
          },
          {
            child_id: 2,
            name: "Gifter",
            route: "/rank-gift-list",
            icon: "mdi:users-group",
          },
          {
            child_id: 3,
            name: "Invite",
            route: "/invite-host-list",
            icon: "mdi:users-group",
          },
        ],
      },
      {
        id: 9,
        name: "Send Diamonds",
        route: "/diamond-list",
        icon: "famicons:diamond",
      },
      {
        id: 10,
        name: "Send Rcoins",
        route: "/coins-history",
        icon: "wpf:coins",
      },
      {
        id: 11,
        name: "Profile Tags",
        icon: "streamline:user-protection-2shield-secure-security-profile-person-remix",
        children: [
          {
            child_id: 1,
            name: "Assign Profile Tags",
            route: "/profile-tag-list",
            icon: "streamline:user-protection-2shield-secure-security-profile-person-remix",
          },
          {
            child_id: 2,
            name: "Profile Tags",
            route: "/assign-profile-tag-users",
            icon: "streamline:user-protection-2shield-secure-security-profile-person-remix",
          },
        ],
      },
      {
        id: 12,
        name: "Livestream Tags",
        icon: "hugeicons:tags",
        children: [
          {
            child_id: 1,
            name: "Assign Live Stream Tags",
            route: "/tagslist",
            icon: "hugeicons:tags",
          },
          {
            child_id: 2,
            name: "Livestream Tag",
            route: "/assigned-users",
            icon: "hugeicons:tags",
          },
        ],
      },
      {
        id: 13,
        name: "Sending Level",
        icon: "carbon:skill-level",
        children: [
          {
            child_id: 1,
            name: "Assign Sending Level",
            route: "/senders-list",
            icon: "carbon:skill-level",
          },
          {
            child_id: 2,
            name: "Sending Level",
            route: "/level-users-list",
            icon: "tabler:users",
          },
        ],
      },
      {
        id: 14,
        name: "Hosting Level",
        icon: "carbon:skill-level",
        children: [
          {
            child_id: 1,
            name: "Assign Hosting Level",
            route: "/hosts-list",
            icon: "carbon:skill-level",
          },
          {
            child_id: 2,
            name: "Hosting Level",
            route: "/host-level-list",
            icon: "tabler:users",
          },
        ],
      },
      {
        id: 15,
        name: "Images",
        route: "/all-images-list",
        icon: "ion:images",
      },
      {
        id: 16,
        name: "Banners",
        icon: "game-icons:vertical-banner",
        children: [
          {
            child_id: 1,
            name: "All Banners",
            route: "/all-banners",
            icon: "game-icons:vertical-banner",
          },
          {
            child_id: 2,
            name: "Inactive Banners",
            route: "/deactive-banners",
            icon: "game-icons:vertical-banner",
          },
          {
            child_id: 3,
            name: "Active Banners",
            route: "/active-banners",
            icon: "game-icons:vertical-banner",
          },
        ],
      },
      {
        id: 17,
        name: "Gifts",
        icon: "fluent-emoji-high-contrast:wrapped-gift",
        children: [
          {
            child_id: 1,
            name: "Gifts",
            route: "/giftlist",
            icon: "fluent-emoji-high-contrast:wrapped-gift",
          },
          {
            child_id: 2,
            name: "Gifts Sent & Receive History",
            route: "/gift-history",
            icon: "maki:gift",
          },
        ],
      },
      {
        id: 18,
        name: "Text Bubbles",
        route: "/text-bubble-list",
        icon: "ion:chatbubbles-sharp",
      },
      {
        id: 19,
        name: "Product Categories",
        route: "/product-categories",
        icon: "ic:outline-category",
      },
      {
        id: 20,
        name: "Products",
        route: "/products",
        icon: "fluent-mdl2:product-variant",
      },
      {
        id: 21,
        name: "SVIP",
        route: "/sviplist",
        icon: "famicons:diamond",
      },
      {
        id: 22,
        name: "Diamond Packages",
        route: "/diamonds-packages",
        icon: "famicons:diamond",
      },
      {
        id: 23,
        name: "Withdraw Payment Methods",
        route: "/withdraw-list",
        icon: "hugeicons:reverse-withdrawal-01",
      },
      {
        id: 24,
        name: "Withdraw Requests",
        route: "/withdraw-request",
        icon: "hugeicons:reverse-withdrawal-01",
      },
      {
        id: 25,
        name: "Reports",
        icon: "mdi:report-finance",
        children: [
          {
            child_id: 1,
            name: "LiveStreams",
            route: "/live-stream-report",
            icon: "mdi:report-finance",
          },
          {
            child_id: 2,
            name: "Moments",
            route: "/report-moment",
            icon: "mdi:report-finance",
          },
          {
            child_id: 3,
            name: "Families",
            route: "/family-report",
            icon: "mdi:report-finance",
          },
          {
            child_id: 4,
            name: "Withdrawals",
            route: "/withdrawal-report",
            icon: "mdi:report-finance",
          },
          {
            child_id: 5,
            name: "User",
            route: "/users-report",
            icon: "mdi:report-finance",
          },
        ],
      },
      {
        id: 26,
        name: "Merchants",
        route: "/merchant",
        icon: "mdi:users-group",
      },
      {
        id: 27,
        name: "Permissions",
        route: "/permissions",
        icon: "hugeicons:finger-access",
      },
      {
        id: 28,
        name: "Sub Admins",
        route: "/admins",
        icon: "eos-icons:admin-outlined",
      },
      {
        id: 29,
        name: "Reseller",
        route: "/reseller-list",
        icon: "arcticons:lazada-seller-center",
      },
      {
        id: 30,
        name: "Customer",
        route: "/customer-list",
        icon: "mdi:customer-service",
      },
      {
        id: 31,
        name: "Customer Chat",
        route: "/customer-csr",
        icon: "line-md:chat",
      },
      {
        id: 32,
        name: "Donation Logs",
        route: "/donation-list",
        icon: "streamline-freehand:donation-charity-donate-bag-2",
      },
      {
        id: 33,
        name: "Wallet Transaction",
        route: "/transaction-list",
        icon: "streamline-freehand-color:modern-payment-desktop-transaction",
      },
      {
        id: 34,
        name: "Gift Ranking History",
        route: "/gift-ranking-list",
        icon: "solar:ranking-bold-duotone",
      },
      {
        id: 35,
        name: "Family Rule",
        route: "/family-rule-list",
        icon: "mdi:family",
      },
    ],
    []
  );
  //filters permissions
  const permittedItems = useMemo(() => {
    const defaultItem = items[0];
    const restItems = items.slice(1);

    if (!permissions || permissions.length === 0) {
      return items;
    }

    const allowedNames = permissions.map((p) => p.name.toLowerCase().trim());

    const filteredItems = restItems.filter((item) =>
      allowedNames.includes(item.name.toLowerCase().trim())
    );

    return [defaultItem, ...filteredItems];
  }, [items, permissions]);
  // sound
  const playBeep = () => {
    const audio = new Audio(beep);
    audio.play().catch((err) => {
      console.warn("Playback prevented:", err);
    });
  };
  // sideBar button
  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const handleCloseSideBar = () => {
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };
  //Socket
  useEffect(() => {
    connectSocket(localStorage.getItem("rocco_live-access-Token-for-web"));
    const newSocket = getSocket();
    setSocket(newSocket);

    newSocket.on("admin:new-customer-message", (data) => {
      setSocketData(data);
      setAlertMessage("New message arrived!");
      setAlertOpen(true);
      playBeep();
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);
  // local Storage
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("user"));
    const newData = data?.permissions;
    setPermissions(newData);
  }, []);
  // mobile screen size
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    } else if (window.innerWidth >= 768) {
      setIsSidebarOpen(true);
    } else {
      setIsSidebarOpen(true);
    }
  }, []);

  return (
    <div className="App">
      {/* SnackBar */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={4000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="info"
          onClose={handleAlertClose}
          onClick={() => {
            setAlertOpen(false);
            navigate("/customer-csr");
          }}
          sx={{ cursor: "pointer" }}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      {/* button || sideBar open */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="drawer-toggle-btn show-hide"
      >
        <Icon
          icon="mdi:fingerprint"
          color={isSidebarOpen ? "#22c55e" : "#666"}
          width="26"
          height="26"
        />
      </button>
      {/* SideBar Content || Li*/}
      {isSidebarOpen && (
        <div className="app-side-bar">
          <img src={roccologo} className="home-rocco-logo" alt="Rocco Logo" />
          <ul className="text-content-link">
            {permittedItems.map((item) => (
              <>
                <div key={item.id}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                    onClick={() => handleitemsClick(item)}
                    className={
                      activeitems === item.id || location === item.route
                        ? "selected-item"
                        : "unselected"
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title={item?.name}>
                        <Icon icon={item?.icon} width="20" height="20" />
                      </Tooltip>
                      <li className="content">{item.name}</li>
                    </div>
                    {item.children && (
                      <Icon
                        icon={
                          openDropdown === item.id
                            ? "mdi:chevron-up"
                            : "mdi:chevron-down"
                        }
                        width="20"
                        height="20"
                      />
                    )}
                  </div>
                  {item.children && openDropdown === item.id && (
                    <ul style={{ paddingLeft: "20px" }}>
                      {item.children.map((child, index) => (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                          onClick={() => handleitemsClick(child)}
                          className={
                            activeChilditems == child.child_id
                              ? "selected-item"
                              : "unselected"
                          }
                        >
                          <Tooltip title={child?.name}>
                            <Icon icon={child?.icon} width="20" height="20" />
                          </Tooltip>
                          {child.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </>
            ))}

            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                position: "fixed",
                bottom: 0,
                left: "3%",
                top: "95%",
              }}
            >
              <div
                className="unselected"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Icon icon={"line-md:logout"} width="20" height="20" />
                <li className="content" onClick={onLogout}>
                  Logout
                </li>
              </div>
            </div>
          </ul>
        </div>
      )}
      {/* Content Side // Routing */}
      <div className="app-right" onClick={handleCloseSideBar}>
        <div className="app-content">
          <Routes>
            <Route path="/coming" element={<ComingSoon />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admins" element={<Admin />} />
            <Route path="/admins/create" element={<AddAdmin />} />
            <Route path="/admin/detail/:id" element={<AdminDetail />} />
            <Route path="/users" element={<User />} />
            <Route path="/profile-users" element={<UserProfile />} />
            <Route path="/users-report" element={<UserReportList />} />
            <Route path="/ban-user" element={<BanUser />} />
            <Route path="/blocklist" element={<Blocklist />} />
            <Route path="/add-banner" element={<AddBanner />} />
            <Route path="/edit-banner/:id" element={<EditBanner />} />
            <Route path="/active-banners" element={<ActiveBanners />} />
            <Route path="/all-banners" element={<AllBannersList />} />
            <Route path="/deactive-banners" element={<DeactiveBanners />} />
            <Route path="/user/detail/:id" element={<UserDetail />} />
            <Route path="/permissions" element={<Permissions />} />
            <Route path="/coins-history" element={<CoinsHistory />} />
            <Route path="/send-coins" element={<SendRcoins />} />
            <Route path="/product-categories" element={<ProductCategories />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/add-product" element={<AddProduct />} />
            <Route path="/products/edit-product/:id" element={<AddProduct />} />
            <Route path="/pk" element={<Pklist />} />
            <Route path="/setpk" element={<SetPk />} />
            <Route path="/tagslist" element={<TagsList />} />
            <Route path="/assigned-users" element={<AssignedUsers />} />
            <Route path="/updatePk/:id" element={<SetPk />} />
            <Route path="/giftlist" element={<GiftList />} />
            <Route path="/gift/:id" element={<CreateGift />} />
            <Route path="/createGift" element={<CreateGift />} />
            <Route path="/diamond-list/add-diamond" element={<AddDiamond />} />
            <Route path="/diamond-list" element={<DiamondList />} />
            <Route path="/withdraw-list" element={<WithdrawPayment />} />
            <Route path="/add-withdraw-list" element={<AddWithdrawPayment />} />
            <Route path="/live-stream-report" element={<LiveStreamReport />} />
            <Route path="/deactivate-user" element={<DeactivateUser />} />
            <Route path="/banned-user" element={<BannedUser />} />
            <Route path="/gift-history" element={<GiftHistoryList />} />
            <Route path="/merchant" element={<Merchand />} />
            <Route path="/add-merchant/:id?" element={<AddMerchand />} />
            <Route path="/host-list" element={<HostRequestList />} />
            <Route path="/donation-list" element={<DonationLog />} />
            <Route path="/transaction-list" element={<WalletTransaction />} />
            <Route path="/gift-ranking-list" element={<GifterRankingList />} />
            <Route path="/rank-host-list" element={<HostList />} />
            <Route path="/invite-host-list" element={<InviteList />} />
            <Route path="/rank-gift-list" element={<GiftListRank />} />
            <Route path="/add-deactive" element={<AddDeactiveUser />} />
            <Route
              path="/withdrawal-report"
              element={<WithdrawalsReportList />}
            />
            <Route
              path="/create-family-rule/:id?"
              element={<CreateFamilyRule />}
            />
            <Route path="/withdraw-request" element={<WithdrawRequestList />} />
            <Route
              path="/single/withdraw/:id?"
              element={<SingleWithdrawRequest />}
            />
            <Route
              path="/approve-video-moments"
              element={<MomentsVideoApprove />}
            />
            <Route
              path="/pending-video-moments"
              element={<MomentsVideoPending />}
            />
            <Route
              path="/reject-video-moments"
              element={<MomentsVideoReject />}
            />
            <Route path="/report-moment" element={<MomentReport />} />
            <Route path="/reseller-list" element={<Reseller />} />
            <Route path="/add-reseller/:id?" element={<AddReseller />} />
            <Route
              path="/customer-csr"
              element={<ChatList socketData={socketData} />}
            />
            <Route path="/customer-list" element={<Customer />} />
            <Route path="/add-customer/:id?" element={<AddCustomer />} />
            <Route
              path="/bussiness-developers"
              element={<BussinessDevelopersList />}
            />
            <Route
              path="/add-bussiness-developer"
              element={<AddBussinessDevelopers />}
            />
            <Route path="/agencylist" element={<AgencyList />} />
            <Route path="/agency/create" element={<AddAgency />} />
            <Route path="/senders-list" element={<SendersLevel />} />
            <Route path="/assign-level" element={<AssignLevel />} />
            <Route path="/add-sender-level" element={<AddSenderLevel />} />
            <Route
              path="/level-users-list"
              element={<AssignLevelUsersList />}
            />
            <Route path="/edit-sender-level" element={<EditSenderLevel />} />
            <Route path="/update-level" element={<UpdateAssignLevel />} />
            <Route path="/hosts-list" element={<HostsLevel />} />
            <Route path="/assign-host-level" element={<AssignHostLevel />} />
            <Route
              path="/host-level-list"
              element={<AssignHostLevelUsersList />}
            />
            <Route path="/add-host-level" element={<AddHostLevel />} />
            <Route path="/edit-host-level" element={<EditHostLevel />} />
            <Route path="/assign-host-level" element={<AssignHostingLevel />} />
            <Route
              path="/update-host-level"
              element={<UpdateAssignHostLevel />}
            />
            <Route path="/diamonds-packages" element={<DiamondsPackages />} />
            <Route path="/add-package" element={<AddPackages />} />
            <Route path="/edit-package/:id" element={<EditPackages />} />
            <Route path="/moments-approve" element={<MomentsApprove />} />
            <Route path="/all-moments" element={<AllMoments />} />
            <Route path="/moments-pending" element={<MomentsPending />} />
            <Route path="/family-rule-list" element={<FamilyRuleList />} />
            <Route path="/family-list/:id?" element={<FamilyList />} />
            <Route path="/family-report" element={<FamilyReport />} />
            <Route path="/text-bubble-list" element={<TextBubbleImages />} />
            <Route path="/add-text-bubble" element={<AddTextBubble />} />
            <Route path="/edit-text-bubble/:id" element={<AddTextBubble />} />
            <Route path="/all-images-list" element={<BannerImagesList />} />
            <Route path="/add-image" element={<AddUpdateImage />} />
            <Route path="/rid-list" element={<RIDList />} />
            <Route path="/profile-tag-list" element={<ProfiletagsList />} />
            <Route
              path="/assign-profile-tag-users"
              element={<ProfileTagUsersList />}
            />
            <Route path="/add-profile-tag" element={<AddUpdateProfileTag />} />
            <Route
              path="/edit-profile-tag/:id"
              element={<AddUpdateProfileTag />}
            />
            <Route path="/add-rid" element={<AddUpdateSpecialRID />} />
            <Route path="/edit-rid/:id" element={<AddUpdateSpecialRID />} />
            <Route path="/edit-image/:id" element={<AddUpdateImage />} />
            <Route path="/edit-family/:id" element={<UpdateFamily />} />
            <Route path="/moments-rejected" element={<MomentsRejected />} />
            <Route path="/agency/detail/:id" element={<AgencyDetail />} />
            <Route path="/agency/edit/:id" element={<EditAgency />} />
            <Route path="/sviplist" element={<SvipList />} />
            <Route path="/svip/create" element={<AddSvip />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;
